import { createStyles, makeStyles } from '@mui/styles'
import type { Theme } from '@mui/material/styles'

/*

Copyright 2022-04-28 por Alfonso Moya Ecomsur Holding S.A ©
Detalle: Se modifica estilo de modal con el objetivo de que pueda usar mas espacio
de la pantalla y que los scrolls solo aparezcan cuando sea necesario.


Copyright 2022-04-28 por Alfonso Moya Ecomsur Holding S.A ©
Detalle: se agregan estilos para modificar tamano desde afuera de la implementacioón del modal.
*/
export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    paperXS: {
      position: 'absolute',
      padding: '10px 60px 20px 60px',
      backgroundColor: theme.palette.background.paper,
      boxShadow: theme.shadows[5],
      minHeight: '25%',

      [theme.breakpoints.down('sm')]: {
        overflow: 'auto',
        padding: '20px',
        minWidth: '85%',
        minHeight: '75%'
      },
      [theme.breakpoints.up('md')]: {
        overflow: 'auto',
        padding: '20px',
        maxWidth: '50%'
      },

      [theme.breakpoints.up('lg')]: {
        overflow: 'auto',
        padding: '20px',
        maxWidth: '35%'
      }
    },

    paperSM: {
      position: 'absolute',
      padding: '10px 60px 20px 60px',
      backgroundColor: theme.palette.background.paper,
      boxShadow: theme.shadows[5],
      maxHeight: '50%',
      minWidth: '50%',

      overflow: 'auto',
      [theme.breakpoints.down('xs')]: {
        padding: '20px'
      },

      [theme.breakpoints.up('sm')]: {
        maxHeight: '90%',

        maxWidth: '90%',
        marginTop: 0
      }
    },

    paperLG: {
      position: 'absolute',
      padding: '0 60px 20px 60px',
      backgroundColor: theme.palette.background.paper,
      boxShadow: theme.shadows[5],
      maxHeight: '80%',
      minWidth: '80%',
      overflow: 'auto',

      [theme.breakpoints.down('sm')]: {
        padding: '20px',
        maxHeight: '75%'
      },

      [theme.breakpoints.up('xs')]: {
        marginTop: 0
      }
    },
    paperTransparent: {
      position: 'absolute',
      padding: '20px 60px 20px 60px',
      boxShadow: theme.shadows[5],
      maxHeight: '75%',

      [theme.breakpoints.up('xs')]: {
        overflow: 'auto',
        maxHeight: '75%'
      },

      [theme.breakpoints.up('md')]: {
        overflow: 'auto',
        maxHeight: '75%'
      },

      [theme.breakpoints.up('md')]: {
        width: '75%',
        overflow: 'auto',
        maxHeight: '75%',
        marginTop: 0,
        backgroundColor: 'green'
      }
    }
  })
)
